import { useState, useEffect } from 'react'
import './App.css'
import HotelDetails from './components/HotelDetails';

function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand" href="/">
          <span className="text-primary">MaxedPoints</span>
          <br />
          <small className="text-muted">Maximize Your Hotel Points</small>
        </a>
        {/* <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link active" href="/">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/alerts">Alerts</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/deals">Deals</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/pricing">Pricing</a>
            </li>
          </ul>
        </div> */}
      </div>
    </nav>
  )
}

function App() {
  const [hotels, setHotels] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const ITEMS_PER_PAGE = 16
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [hotelAvailability, setHotelAvailability] = useState(null);
  const [loadingAvailability, setLoadingAvailability] = useState(false);
  const [hotelDetails, setHotelDetails] = useState(null);

  useEffect(() => {
    fetchHotels()
  }, [page])

  const fetchHotels = async () => {
    try {
      const offset = (page - 1) * ITEMS_PER_PAGE
      const response = await fetch(
        `https://maxmypoint.com/hotels?search=&sort=&order=&offset=${offset}&limit=${ITEMS_PER_PAGE}&brand=Hyatt%2CIHG%2CHilton%2CMarriott%2C&sub_brands=&cats=&min_points=&max_points=`
      )
      const data = await response.json()
      
      if (data.rows.length < ITEMS_PER_PAGE) {
        setHasMore(false)
      }

      setHotels(prevHotels => {
        const uniqueHotels = [...prevHotels];
        data.rows.forEach(newHotel => {
          if (!uniqueHotels.some(hotel => hotel.id === newHotel.id)) {
            uniqueHotels.push(newHotel);
          }
        });
        return uniqueHotels;
      });
      setLoading(false)
    } catch (error) {
      console.error('Error fetching hotels:', error)
      setLoading(false)
    }
  }

  const loadMore = () => {
    setPage(prevPage => prevPage + 1)
  }

  const handleHotelClick = async (hotel) => {
    console.log('Clicked hotel:', hotel);
    setSelectedHotel(hotel);
    setLoadingAvailability(true);
    try {
      const response = await fetch(`https://maxmypoint.com/hotel-rewards-avail?id=${hotel.id}&nights=1`);
      console.log('Details response:', response);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Availability data:', data);
      setHotelDetails(data);
      setHotelAvailability(data.hra);
    } catch (error) {
      console.error('Error fetching hotel data:', error);
      setHotelDetails(null);
      setHotelAvailability(null);
    } finally {
      setLoadingAvailability(false);
    }
  };

  if (loading && page === 1) {
    return <div className="loading">Loading...</div>
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      
      <main className="flex-grow-1">
        <div className="container py-4">
          <h1 className="text-center mb-4">Find Your Perfect Hotel Redemption</h1>
          <p className="text-center text-muted mb-5">
            Compare hotel point values across major loyalty programs including Hyatt, IHG, Hilton, and Marriott
          </p>
          
          <div className="hotel-grid">
            {hotels.map((hotel) => (
              <div 
                key={hotel.id} 
                className="hotel-card"
              >
                <div className="hotel-image">
                  <img src={hotel.image} alt={hotel.name} />
                  <span className="availability">{hotel.availability} Availability</span>
                </div>
                <div className="hotel-info">
                  <h2>{hotel.name}</h2>
                  <p className="location">{hotel.caption}</p>
                  <div className="hotel-details">
                    <div className="brand-info">
                      <span className="brand">{hotel.brand}</span>
                      <span className="sub-brand">{hotel.sub_brand}</span>
                    </div>
                    <div className="points-info">
                      <span className="points">{hotel.medianp} points</span>
                      <span className="value">Value: {hotel.median_value}¢/point</span>
                    </div>
                  </div>
                  <button 
                    className="btn btn-primary mt-2"
                    onClick={() => handleHotelClick(hotel)}
                  >
                    View Availability
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          {hasMore && (
            <div className="text-center mt-4 mb-4">
              <button 
                className="btn btn-primary"
                onClick={loadMore}
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Load More'}
              </button>
            </div>
          )}
        </div>
        
        {selectedHotel && (
          <HotelDetails
            hotel={selectedHotel}
            hotelDetails={hotelDetails}
            availability={hotelAvailability}
            onClose={() => {
              setSelectedHotel(null);
              setHotelDetails(null);
              setHotelAvailability(null);
            }}
            loading={loadingAvailability}
          />
        )}
      </main>
      
  
    </div>
  )
}

export default App
